'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import Navbar from '../../../../components/Navbar';
import Footer from '../../../../components/Footer';
import HorizontalFilterBar from '../../../../components/HorizontalFilterBar';
import FilterPanel from '../../../../components/FilterPanel';
import { api } from '@/lib/apiClient';
import { useSearchParams, useRouter } from 'next/navigation';
import AdBanner from '../../../../components/AdBanner';
import Cookies from 'js-cookie';

const BASE_URL = process.env.NEXT_PUBLIC_API_URL || '/api/proxy/';

// Mock projects data
const mockProjects = [
    {
        id: 'proj-001',
        name: 'DreamAcres Heights',
        developer: 'DreamAcres Builders',
        location: 'OMR, Chennai',
        city: 'Chennai',
        image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=600',
        priceRange: '₹65L - ₹1.2Cr',
        configurations: ['2 BHK', '3 BHK', '4 BHK'],
        status: 'Under Construction',
        possession: 'Dec 2025',
        totalUnits: 450,
        availableUnits: 124,
        amenities: ['Swimming Pool', 'Gym', 'Club House', 'Garden'],
        isRera: true,
        isFeatured: true,
    },
    {
        id: 'proj-002',
        name: 'Urban Oasis',
        developer: 'Skyline Developers',
        location: 'Anna Nagar, Chennai',
        city: 'Chennai',
        image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600',
        priceRange: '₹85L - ₹1.8Cr',
        configurations: ['3 BHK', '4 BHK'],
        status: 'Ready to Move',
        possession: 'Ready',
        totalUnits: 280,
        availableUnits: 45,
        amenities: ['Swimming Pool', 'Gym', 'Tennis Court', 'Jogging Track'],
        isRera: true,
        isFeatured: true,
    },
    {
        id: 'proj-003',
        name: 'Green Valley Villas',
        developer: 'Nature Homes',
        location: 'ECR, Chennai',
        city: 'Chennai',
        image: 'https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=600',
        priceRange: '₹1.5Cr - ₹3.5Cr',
        configurations: ['3 BHK Villa', '4 BHK Villa'],
        status: 'Under Construction',
        possession: 'Mar 2026',
        totalUnits: 85,
        availableUnits: 32,
        amenities: ['Private Garden', 'Club House', 'Security', 'Power Backup'],
        isRera: true,
        isFeatured: false,
    },
    {
        id: 'proj-004',
        name: 'Metro Heights',
        developer: 'City Builders',
        location: 'Velachery, Chennai',
        city: 'Chennai',
        image: 'https://images.unsplash.com/photo-1574362848149-11496d93a7c7?w=600',
        priceRange: '₹55L - ₹95L',
        configurations: ['2 BHK', '3 BHK'],
        status: 'Under Construction',
        possession: 'Jun 2025',
        totalUnits: 320,
        availableUnits: 89,
        amenities: ['Gym', 'Children Play Area', 'Parking', 'Security'],
        isRera: true,
        isFeatured: false,
    },
];



const property = {
    agent: {
        name: "John Doe",
        role: "Property Agent"
    },
    costs: {
        rent: 25000,
        deposit: 300000
    }
};

const sortOptions = [
    { value: 'relevance', label: 'Relevance' },
    { value: 'newest', label: 'Newest First' },
    { value: 'price_low', label: 'Price: Low to High' },
    { value: 'price_high', label: 'Price: High to Low' },
];

function convertToArray(str) {
    if (!str) return [];
    return str.split('-').map(num => parseInt(num, 10));
}

export default function ProjectsListingPage() {
    const [filters, setFilters] = useState({});
    const [sortBy, setSortBy] = useState('relevance');
    const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);
    const [mockProjects, setMockProjects] = useState([]);
    const [viewMode, setViewMode] = useState('grid');
    const searchParams = useSearchParams();
    const router = useRouter();
    const cityId = searchParams.get("cityId");
    const [city_name, setCityName] = useState("");
    const [localities, setLocalities] = useState("");
    const [parms, setParms] = useState("");
    const [showInterestedPopup, setShowInterestedPopup] = useState(false);
    const [isLoggedInContext, setIsLoggedInContext] = useState(false);

    const token = Cookies.get('token');
    const isLoggedIn = !!token;

    // Read localities from query params if any are present
    const localitiesParam = searchParams.get("localities");
    const initialLocalities = localitiesParam ? localitiesParam.split('-').map(num => parseInt(num, 10)) : [];

    const [localitiesIds, setLocalitiesIds] = useState(initialLocalities);

    useEffect(() => {
        fetchProperties();
    }, [searchParams]);

    const fetchProperties = async () => {
        try {
            const localitiesArray = convertToArray(searchParams.get("localities"));
            setParms(searchParams.toString());
            setLocalitiesIds(localitiesArray);
            let whereClause = "city_id=$1";
            let params = [cityId];

            const res = await api.post('selectwithout/view_home_cities', { sqlData: "*", where: "id=$1", whereData: [cityId] });
            //console.log("res.data", res.data);
            let city_name = res.data[0].name;
            setCityName(city_name);
            if (localitiesArray && localitiesArray.length > 0) {
                const res1 = await api.post('selectwithout/master_localities', {
                    sqlData: "locality_name as name",
                    where: "id = ANY($1)",
                    whereData: [localitiesArray],
                });
                if (res1.success === 1 && Array.isArray(res1.data)) {
                    let localitiesNames = "";
                    for (let i = 0; i < res1.data.length; i++) {
                        localitiesNames += res1.data[i].name + ", ";
                    }
                    setLocalities(localitiesNames);
                }
            } else {
                setLocalities("");
            }

            if (localitiesArray && localitiesArray.length > 0) {
                whereClause += " and locality_id = ANY($2)";
                params.push(localitiesArray);
            }

            whereClause += " order by created_at desc";

            const response = await api.post('selectwithout/view_home_projects',
                {
                    sqlData: "*",
                    where: whereClause,
                    whereData: params,
                });
            console.log("response.data", response.data);
            setMockProjects(response.data);
        } catch (error) {
            console.error('Error fetching properties:', error);
        }
    };

    // Filter logic (mock)
    const filteredProjects = mockProjects.filter(project => {
        // Implement actual filtering logic here based on 'filters' object
        // Example: if (filters.status && !filters.status.includes(project.status)) return false;
        return true;
    });

    const handleFilterChange = (newFilters) => {
        setFilters(newFilters);
        console.log('Project Filters changed:', newFilters);
    };

    return (
        <>
            <Navbar />
            <main className="min-h-screen bg-gray-50">
                {/* Horizontal Filter Bar - Sticky */}
                <div className="hidden lg:block sticky top-16 z-40 shadow-lg shadow-primary/10">
                    <HorizontalFilterBar
                        filters={filters}
                        onChange={handleFilterChange}
                        listingType="projects"
                    />
                </div>

                {/* Page Header */}
                <div className="bg-gray">
                    <div className="container-custom py-4">
                        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mt-5 mb-3">
                            {/* LEFT - Breadcrumb */}
                            <nav
                                className="flex flex-wrap items-center gap-2 text-sm text-gray-500 w-full"
                                aria-label="Breadcrumb"
                            >
                                <span className="text-gray-900 font-medium">
                                    <strong>Available {filteredProjects.length} Projects</strong> in {city_name}
                                </span>
                            </nav>

                            {/* RIGHT - Sort */}
                            {/* <div className="flex items-center justify-between md:justify-end gap-2 w-full md:w-auto">
                                <label htmlFor="sortBy" className="text-sm text-gray-600 whitespace-nowrap">
                                    Sort by:
                                </label>

                                <select
                                    id="sortBy"
                                    value={sortBy}
                                    onChange={(e) => setSortBy(e.target.value)}
                                    className="h-9 w-full md:w-auto text-sm px-2 rounded-md bg-white border border-gray-300 text-gray-700 shadow-sm focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
                                >
                                    {sortOptions.map((opt) => (
                                        <option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </option>
                                    ))}
                                </select>
                            </div> */}
                        </div>
                    </div>
                </div>

                {/* Main Content Split Layout */}
                <div className="container-custom">
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mt-4 items-start">

                        {/* Left: Project List (8 cols) */}
                        <div className="lg:col-span-8 flex flex-col gap-6">

                            {/* Mobile Filter Button */}
                            <div className="lg:hidden fixed bottom-0 left-0 right-0 z-10 bg-white border-t shadow-lg p-4">
                                <button
                                    onClick={() => setIsMobileFilterOpen(true)}
                                    className="btn btn-primary w-full flex justify-between items-center"
                                >
                                    <span className="flex items-center gap-2">
                                        <svg
                                            className="w-5 h-5"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
                                            />
                                        </svg>
                                        Filters
                                    </span>

                                    {Object.keys(filters).length > 0 && (
                                        <span className="bg-primary text-white text-xs px-2 py-0.5 rounded-full">
                                            {Object.keys(filters).length}
                                        </span>
                                    )}
                                </button>
                            </div>

                            {/* Projects List */}
                            {filteredProjects.map((project) => (
                                <Link
                                    key={project.id}
                                    href={`/projects/p/${project.id}?${parms}`}
                                    className="group relative flex flex-col md:flex-row bg-white rounded-2xl border border-slate-200 overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
                                >
                                    {/* Image Section */}
                                    <div className="relative md:w-72 md:shrink-0 h-64 md:h-auto overflow-hidden">
                                        <img
                                            src={project.image ? (project.image.startsWith('http') ? project.image : `${BASE_URL}${project.image}`) : '/no-image.jpeg'}
                                            alt={project.name}
                                            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                                        />
                                        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-60 md:opacity-30" />

                                        {/* Badges */}
                                        <div className="absolute top-3 left-3 flex flex-col gap-2">
                                            {/* {project.isFeatured && (
                                                <span className="px-2 py-1 text-xs font-bold uppercase bg-yellow-400 text-yellow-900 rounded shadow-sm w-fit">
                                                    Featured
                                                </span>
                                            )} */}
                                            {project.isRera && (
                                                <span className="px-2 py-1 text-xs font-bold uppercase bg-green-500 text-white rounded shadow-sm w-fit">
                                                    RERA Reg
                                                </span>
                                            )}
                                        </div>

                                        {/* Status Badge (Bottom Left on Image) */}
                                        <div className="absolute bottom-3 left-3">
                                            <span className={`px-2.5 py-1 text-xs font-semibold rounded-full shadow-sm backdrop-blur-md ${project.status === 'Ready to Move' ? 'bg-green-500/90 text-white' : 'bg-orange-500/90 text-white'
                                                }`}>
                                                {project.status}
                                            </span>
                                        </div>
                                    </div>

                                    {/* Content Section */}
                                    <div className="flex-1 p-5 lg:p-6 flex flex-col">

                                        <div className="flex justify-between items-start mb-1">
                                            <div>
                                                <h3 className="text-xl font-bold text-gray-900 group-hover:text-primary transition-colors line-clamp-1">
                                                    {project.name}
                                                </h3>
                                                <p className="text-sm text-gray-500 font-medium mb-2">{project.developer}</p>
                                            </div>
                                            <div className="text-right">
                                                <div className="text-lg lg:text-xl font-bold text-gray-900 whitespace-nowrap">
                                                    {project.priceRange}
                                                </div>
                                                <div className="text-xs text-gray-500">onwards</div>
                                            </div>
                                        </div>

                                        {/* Location */}
                                        <p className="flex items-center gap-1.5 text-gray-600 text-sm mb-4">
                                            <svg className="w-4 h-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                            </svg>
                                            <span className="truncate">{project.location}</span>
                                        </p>

                                        {/* Configs & Possession */}
                                        <div className="bg-gray-50 rounded-lg p-3 mb-4 grid grid-cols-2 gap-y-2 gap-x-4">
                                            <div>
                                                <span className="block text-xs text-gray-500 uppercase font-semibold">Configurations</span>
                                                <span className="text-sm font-medium text-gray-800">{project.configurations?.join(', ')}</span>
                                            </div>
                                            <div>
                                                <span className="block text-xs text-gray-500 uppercase font-semibold">Possession</span>
                                                <span className="text-sm font-medium text-gray-800">{project.possession}</span>
                                            </div>
                                        </div>

                                        {/* Amenities Preview */}
                                        <div className="flex gap-2 mb-4 overflow-hidden">
                                            {project.amenities?.slice(0, 3).map((amenity, idx) => (
                                                <span key={idx} className="px-2 py-1 bg-white border border-gray-200 rounded text-xs text-gray-600 whitespace-nowrap">
                                                    {amenity}
                                                </span>
                                            ))}
                                            {project.amenities?.length > 3 && (
                                                <span className="px-2 py-1 text-xs text-gray-400">+{project.amenities.length - 3} more</span>
                                            )}
                                        </div>

                                        {/* CTA */}
                                        <div className="mt-auto pt-4 border-t border-gray-100 flex items-center justify-between">
                                            <div className="text-sm text-gray-500">
                                                <strong>{project.availableUnits}</strong> units left
                                            </div>
                                            <span className="text-sm font-bold text-primary group-hover:underline flex items-center gap-1">
                                                View Details
                                                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                                                </svg>
                                            </span>
                                        </div>
                                    </div>
                                </Link>
                            ))}

                            {/* Load More */}
                            {/* <div className="mt-8 text-center">
                                <button className="btn btn-white border border-gray-200 hover:border-primary hover:text-primary px-8 w-full sm:w-auto">
                                    Load More Projects
                                </button>
                            </div> */}
                        </div>

                        {/* Right: Ad Sidebar (4 cols) */}
                        <aside className="lg:col-span-4 hidden lg:flex flex-col gap-6 self-start sticky top-24 max-h-[calc(100vh-6rem)] overflow-auto" aria-label="Sidebar">
                            {/* Featured / Ad Widget */}
                            {/* <div className="p-6 bg-violet-50 rounded-2xl border border-violet-100">
                                <h3 className="text-lg font-bold text-violet-900 mb-2">Need Help Buying?</h3>
                                <p className="text-sm text-violet-700 mb-4">
                                    Connect with our experts for site visits and paperwork.
                                </p>
                                <button className="w-full btn bg-violet-600 text-white hover:bg-violet-700 border-none" aria-label="Contact rental expert">
                                    Contact Expert
                                </button>
                            </div> */}

                            {/* Ad Banners */}
                            <AdBanner
                                type="projects"
                                noofads={2}
                            />
                        </aside>

                    </div>
                </div>

                {/* Mobile Filter Modal */}
                {isMobileFilterOpen && (
                    <div className="fixed inset-0 z-50 lg:hidden">
                        <div
                            className="absolute inset-0 bg-black/50"
                            onClick={() => setIsMobileFilterOpen(false)}
                        />
                        <div className="absolute right-0 top-0 bottom-0 w-full max-w-sm bg-white overflow-y-auto">
                            <FilterPanel
                                filters={filters}
                                onChange={handleFilterChange}
                                listingType="projects" // Pass project type
                                isMobile={true}
                                onClose={() => setIsMobileFilterOpen(false)}
                            />
                        </div>
                    </div>
                )}
            </main>
            <Footer />
        </>
    );
}
